import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
function NewTask({elem ,data,setLoggedInUserData}) {
  const { id } = useParams();
  const AcceptIt=()=>{
    if(data){
      const newtask=data.tasks.map((updatedTask,index)=>{
        if(updatedTask.title===elem.title){
          return {active:true,category: updatedTask.category,completed: false,date: updatedTask.date,description: updatedTask.description,failed: false,newTask: false,title: updatedTask.title};
        }else{
          return data.tasks[index];
        }
      })
      let updatedUser={id:data.id,name:data.name,email:data.email,password:data.password,taskCounts:{active:data.taskCounts.active+1,newTask:data.taskCounts.newTask-1,completed:data.taskCounts.completed,failed:data.taskCounts.failed},tasks:newtask}
      setLoggedInUserData(updatedUser)
      axios.put(`https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2/${id}`,{
       tasks:newtask,
        taskCounts:{active:data.taskCounts.active+1,newTask:data.taskCounts.newTask-1,completed:data.taskCounts.completed,failed:data.taskCounts.failed}
      });
    } 
  }
  return (
    <div className="col-md-6 mb-4">
      <div className="newtask new_task">
        <div className="date">
          <span className="high">{elem.category}</span>
          <p>{elem.date}</p>
        </div>
        <h2>{elem.title}</h2>
        <p>
          {elem.description}
        </p>
        <div>
          <button className="accept-task" onClick={AcceptIt}>
            Accept Task
          </button>
        </div>
      </div>
    </div>
  );
}

export default NewTask;
